<template>
  <section id="contact-us" class="contact-us">
    <div class="row">
      <div class="column small-12 large-2 column-image">
        <LogoLink />
      </div>
      <div class="column small-12 large-10">
        <h2>SKONTAKTUJ SIĘ Z&nbsp;NAMI</h2>
        <div class="row row-contact-info">
          <div class="column contact-info">
            NAPISZ NA <br />
            <a href="mailto:KROLEWSKIE@G3GROUP.PL">KROLEWSKIE@G3GROUP.PL</a>
          </div>
          <div class="column">
            <div class="contact-info">ZADZWOŃ pod: <a href="tel:+48221004545">22 100 45 45</a></div>
            <p class="contact-description">
              Infolinia działa w&nbsp;dni robocze, w&nbsp;godzinach od&nbsp;09:00 do&nbsp;16:00. Opłata za połączenie według stawki operatora, z&nbsp;którego
              korzysta uczestnik.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import LogoLink from '../../components/common/LogoLink.vue'

export default {
  name: 'ContactUs',
  components: {
    LogoLink
  }
}
</script>

<style lang="scss" scoped>
.contact-us {
  background-color: #d92a27;
  background-image: url('/images/2026/contact-bg.png');
  background-size: 100% 100%;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  text-align: center;

  @include media-up(md) {
    padding-top: 2rem;
    padding-bottom: 2rem;
    text-align: left;
  }

  > .row {
    justify-content: center;
    gap: 0.25rem;
  }

  h2 {
    margin-bottom: 1.5rem;
  }

  .column-image {
    width: 106px;
    flex-basis: 106px;
    flex-shrink: 0;
    flex-grow: 0;

    ::v-deep img {
      width: 100%;
      height: auto;
    }

    @include media-up(md) {
      width: 168px;
      flex-basis: 168px;
      margin-left: -44px;
      margin-right: 20px;
    }
  }

  .row-contact-info {
    flex-direction: column;
    gap: 2rem;

    @include media-up(md) {
      flex-direction: row;
    }
  }

  .contact-info {
    font-family: $regular-font;
    font-weight: 700;
    text-transform: uppercase;
    font-size: 0.875rem;
    line-height: 1.5;
    margin-bottom: 0.5rem;

    a {
      color: $text-color;
    }

    @include media-up(lg) {
      font-family: $bold-font;
      font-weight: 900;
      font-size: 1.25rem;
    }
  }

  .contact-description {
    font-size: 0.75rem;
    line-height: 1rem;

    @include media-up(lg) {
      font-size: 0.875rem;
      line-height: 1.5rem;
    }
  }
}
</style>
